import classNames from 'classnames'
import { LinkButton } from '@/atoms/Button'
import { FlexColumn } from '@/atoms/FlexContainers'
import { HeadingLG, LabelMD, ParagraphSM, TitleSM } from '@/atoms/Text'
import { paths } from '@/constants/paths'
import { useTranslate } from '@/utils/translate/translate-client'

interface TextOverlayProps {
  className: string
}

export const TextOverlay: React.FC<TextOverlayProps> = ({ className }) => {
  const { t } = useTranslate('about')

  return (
    <div className={classNames(className)}>
      <FlexColumn className="gap-8">
        <FlexColumn className="gap-4">
          <TitleSM className="md:photon-title-lg" weight="semibold">
            {t('ourMission', 'Our Mission')}
          </TitleSM>
          <HeadingLG className="md:photon-heading-xl lg:photon-display md:max-w-[356px] lg:max-w-none" weight="bold">
            {t('HomeStoriesAmplifyHeader', `A Home for Stories That Amplify Light`)}
          </HeadingLG>
          <ParagraphSM className="md:photon-paragraph-md lg:photon-paragraph-lg">
            {t(
              'powerStorytellingParagraph',
              `At Angel, we believe in the power of storytelling to amplify light. This guiding principle is our North Star—it sheds light in the darkness and keeps our focus on what is good, beautiful, and worth sharing. And, through your support and involvement, you play a vital role in helping us decide which stories to bring to life.`,
            )}
          </ParagraphSM>
        </FlexColumn>
        <LinkButton className="h-12 md:h-[56px] md:w-1/2 xl:w-1/4" href={paths.about.ourMission} variant="white">
          <LabelMD className="md:photon-label-lg">{t('learnMore', 'Learn More')}</LabelMD>
        </LinkButton>
      </FlexColumn>
    </div>
  )
}
